import { render, staticRenderFns } from "./BalaDetail.vue?vue&type=template&id=2d3f4530&scoped=true"
import script from "./BalaDetail.vue?vue&type=script&lang=js"
export * from "./BalaDetail.vue?vue&type=script&lang=js"
import style0 from "./BalaDetail.vue?vue&type=style&index=0&id=2d3f4530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f4530",
  null
  
)

export default component.exports